import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";
import * as actions from "actions";
import { clearDeviceList, checkOnlineStatus } from "actions";
import { DisableDeviceSkillset } from "./../../actions/index";
import {} from "@material-ui/core";
import WarnignModalPopup from "../Modal/WarningModal";
import {
  ZuiButton,
  ZuiProgressRing,
  ZuiToggleSwitch,
  ZuiIconEwiInfo,
} from "@zeiss/zui-react";
import {} from "@zeiss/zui";
import useStyles from "../KeyTypes/CommonStyle";
import InternetDisconnected from "../Modal/InternetDisconnected";

const DisableSkillset = (props) => {
  const classes = useStyles();
  const history = useHistory();
  const { reduxState, reduxActions } = props;
  const { deviceListInfo } = reduxState;
  const { GetDeviceByDeviceId } = reduxActions;

  const [updateSkillStatus, setUpdateSkillStatus] = useState("pending");
  const [isDeviceListReady, setDeviceListReady] = useState(false);

  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [onlineStatus, setOnlineStatus] = useState(false);

  const [isActiveState, setIsActiveState] = useState("Enabled");
  const [isUpdateSuccess, setIsUpdateSuccess] = useState(false);

  const token = useSelector((state) => state.userAccount.tokenId);

  const deviceCode =
    props.location.state !== undefined ? props.location.state.deviceCode : null;
  const role =
    props.location.state !== undefined ? props.location.state.role : undefined;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearDeviceList());
    setIsLoading(true);
  }, [dispatch]);

  useEffect(() => {
    if (
      (!isDeviceListReady && deviceListInfo.fetched === "pending") ||
      (isActiveState !== "" && isUpdateSuccess)
    ) {
      GetDeviceByDeviceId(deviceCode, role);
      setIsLoading(false);
      setIsUpdateSuccess(false);
    }
    if (deviceListInfo.fetched === "fetched") {
      setDeviceListReady(true);
      setIsLoading(false);
    }
    if (
      deviceListInfo.isSuccess === false &&
      (deviceListInfo.fetched === "failed" ||
        deviceListInfo.fetched === "unAuthorize")
    ) {
      displayPopUp(deviceListInfo.errorMessage);
      setIsLoading(false);
    }
  }, [
    GetDeviceByDeviceId,
    deviceCode,
    deviceListInfo,
    isDeviceListReady,
    role,
    isActiveState,
    isUpdateSuccess,
  ]);

  const displayPopUp = (text) => {
    setErrorText(text);
    setIsError(true);
  };

  const handleClose = () => {
    setIsLoading(true);
    setIsError(false);
    setErrorText("");
    if (
      deviceListInfo.fetched === "unAuthorize" ||
      updateSkillStatus === "unAuthorize"
    ) {
      logOut();
    } else {
      setIsLoading(false);
      setUpdateSkillStatus("fulfilled");
    }
  };

  const logOut = () => {
    let path = window.location.origin + "/Logout";
    window.location.href = path;
  };

  const closeOnlineStatus = () => {
    setOnlineStatus(false);
  };

  const updateDisableSkillset = async ({ id, isActive }) => {
    const deviceId = deviceListInfo.deviceListByID.id;
    setIsLoading(true);
    let onlineStatus = await checkOnlineStatus();
    if (onlineStatus !== false) {
      const result = await DisableDeviceSkillset(token, {
        deviceId,
        id,
        isActive,
      });
      if (result.status === true) {
        setIsUpdateSuccess(true);
        setIsActiveState("");
      } else {
        if (result.statusCode === 401) {
          setUpdateSkillStatus("unAuthorize");
          displayPopUp(result.message);
        } else if (result.statusCode === 400) {
          //Reload the page as the data already exists in server
          setIsUpdateSuccess(true);
          setIsActiveState("");
        } else {
          setUpdateSkillStatus("failed");
          displayPopUp(result.message);
        }
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      setOnlineStatus(true);
    }
  };

  return isLoading || deviceListInfo.fetched === "pending" ? (
    <div className={classes.root}>
      <div
        className={`${classes.progressRoot} ${classes.progress}`}
        role="progressbar"
        style={{ width: "40px", height: "40px" }}>
        <ZuiProgressRing size="m"></ZuiProgressRing>
      </div>
      <div className={classes.progressText}>{"Please wait.."}</div>
    </div>
  ) : deviceListInfo.fetched === "fulfilled" ? (
    <div style={{ width: "100%", fontFamily: "Segoe UI" }}>
      <div
        // show-searchbar={false}
        style={{
          margin: "8px",
          width: "98.5%",
          background: "var(	--zui-color-gs-10)",
          display: "flex",
        }}>
        <p style={{ padding: "20px", margin: "0" }}>Device: </p>
        <p
          style={{
            padding: "18px 0 18px 0px",
            textTransform: "uppercase",
            fontSize: "16px !important",
            lineHeight: "24px !important",
            margin: "0",
            color: "#1A2329",
            font: "var(--zui-typography-h4)",
          }}>
          {deviceListInfo.deviceListByID.name}
          <span
            style={{
              padding: "18px 0 18px 16px",
              fontSize: "14px !important",
              lineHeight: "20px !important",
              color: "#353D45",
              font: "var(--zui-typography-body)",
              margin: "auto",
            }}>
            ({deviceListInfo.deviceListByID.icCode})
          </span>
        </p>
      </div>
      <div
        style={{
          margin: "8px 8px 1px 8px",
          width: "98.5%",
          background: "#F5F7FA",
          display: "flex",
          padding: "15px 0 15px 24px",
          font: "var(--zui-typography-subtitle2)",
          fontSize: "12px !important",
          lineHeight: "16px !important",
          color: "#555E6B",
        }}>
        {"Disable Skillsets"}
      </div>
      <div
        style={{
          background: "var(	--zui-color-gs-10)",
          margin: "2px 8px 8px 8px",
          width: "98.5%",
          height: "calc(100% - 32%)",
          overflow: "auto",
        }}>
        {deviceListInfo.deviceListByID.skills.map((item, index) => {
          const isDisabled = item.isActive ? "" : classes.fadeDisplay;
          return (
            <div
              key={"skills" + index}
              className={isDisabled}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "20px 40px",
                borderBottom: "1px solid #c1cbd9",
              }}>
              {item.name}
              <ZuiToggleSwitch
                key={item.id}
                name={item.name}
                value={item.isActive}
                emphasis="primary"
                onClick={(e) => {
                  const isActiveValue = item.isActive ? "Enabled" : "Disabled";
                  setIsActiveState(isActiveValue);
                  updateDisableSkillset({
                    id: item.id,
                    isActive: e.target.value,
                  });
                }}></ZuiToggleSwitch>
            </div>
          );
        })}
      </div>
      <div className={`${classes.adminfixedFooter}`}>
        <div
          className={`${classes.adminfooterContainer} `}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "8px 16px",
          }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <ZuiIconEwiInfo
              // size="l"
              // style={{
              //   position: "absolute",
              //   width: "30px",
              //   height: "30px",
              //   left: "13px",
              //   top: "7px",
              //   }}
              ></ZuiIconEwiInfo>
            <span
                style={{
                marginLeft:"8px",
                // position: "absolute",
                // left: "48px",
                // right: "0px",
                // top: "15.62%",
                // bottom: "21.88%",
                // display: "flex",
                // alignItems: "center",
              }}>
              {"All the Applicable Keytypes will also be disabled"}
            </span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}>
            <ZuiButton
              size="s"
              title="Back"
              environment="auto"
              onClick={() => {
                history.push({
                  pathname: "/home/Devices/ViewDeviceDetails",
                  state: { deviceCode: deviceCode, role: role },
                });
              }}>
              {"Back"}
            </ZuiButton>
          </div>
          {/* <div style={{ padding: "15px" }}>
            <ZuiButton
              size="s"
              title="Update"
              environment="auto"
              emphasis="active-primary"
              onClick={() => updateDisableSkillset()}>
              {"Update"}
            </ZuiButton>
          </div> */}
        </div>
      </div>
      <div id="fseModalPopup">
        <WarnignModalPopup
          state={isError}
          title={errorText}
          clickClose={handleClose}
        />
      </div>
      <InternetDisconnected
        state={onlineStatus}
        clickClose={closeOnlineStatus}></InternetDisconnected>
    </div>
  ) : (
    <>
      {(updateSkillStatus === "failed" ||
        updateSkillStatus === "unAuthorize" ||
        deviceListInfo.fetched === "failed" ||
        deviceListInfo.fetched === "unAuthorize") &&
      isError ? (
        <div id="fseModalPopup">
          <WarnignModalPopup
            state={isError}
            title={errorText}
            clickClose={handleClose}
          />
        </div>
      ) : (
        <div
          id="div_AdminDeviceList_Conainer"
          className={`${classes.divContainer}`}
          style={{ margin: "8px 8px 0px 8px" }}>
          <div
            id="div_selection"
            className={`${classes.divSelectionContainer} ${classes.displayFlex}`}>
            <div id="form_label" className={`${classes.formLable}`}>
              {"Unable to retrieve data from the server"}
            </div>
            <div id="form_Select_all" className={classes.divSelectAll}>
              <button
                className={`${classes.btnSelectAll} cursorPoiner`}
                onClick={() => {
                  window.location.reload(true);
                }}>
                {"Reload"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  reduxActions: bindActionCreators(
    {
      GetDeviceByDeviceId: actions.GetDeviceByDeviceCode,
    },
    dispatch
  ),
});

const mapStateToProps = (state) => ({
  reduxState: {
    deviceListInfo: state.deviceListInfo,
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DisableSkillset);
